import React from 'react';
import { AiCornerAgent, AiSearchTrigger, AiSearchTriggerFloating, useAiWidgetConfig } from '../../index';

/**
 * AiSearchTrigger with props from the AiWidgetConfigProvider
 */
export var AiSearchTriggerWithContext = function AiSearchTriggerWithContext() {
  var _useAiWidgetConfig = useAiWidgetConfig(),
    supportWidgetConfig = _useAiWidgetConfig.supportWidgetConfig;
  return /*#__PURE__*/React.createElement(AiSearchTrigger, {
    site: supportWidgetConfig.site,
    siteId: supportWidgetConfig.siteId,
    widgetId: supportWidgetConfig.widgetId,
    widgetTheme: supportWidgetConfig.widgetTheme
  });
};

/**
 * AiSearchTriggerFloating with props from the AiWidgetConfigProvider
 */
export var AiSearchTriggerFloatingWithContext = function AiSearchTriggerFloatingWithContext() {
  var _useAiWidgetConfig2 = useAiWidgetConfig(),
    supportWidgetConfig = _useAiWidgetConfig2.supportWidgetConfig;
  return /*#__PURE__*/React.createElement(AiSearchTriggerFloating, {
    site: supportWidgetConfig.site,
    siteId: supportWidgetConfig.siteId,
    widgetId: supportWidgetConfig.widgetId,
    widgetTheme: supportWidgetConfig.widgetTheme
  });
};

/**
 * AiCornerAgent with props from the AiWidgetConfigProvider
 */
export var AiCornerAgentWithContext = function AiCornerAgentWithContext() {
  var _useAiWidgetConfig3 = useAiWidgetConfig(),
    supportWidgetConfig = _useAiWidgetConfig3.supportWidgetConfig;
  return /*#__PURE__*/React.createElement(AiCornerAgent, {
    site: supportWidgetConfig.site,
    siteId: supportWidgetConfig.siteId,
    widgetId: supportWidgetConfig.widgetId
  });
};